<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Report-Import-List",
  path: "list",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
